export default __webpack_public_path__ + "static/media/isp.f7580031.svg";